<template>
    <div class="loading-blk">
        <img src="@/assets/img/ajax-loader.gif" width="100" />
        Content is loading, please wait....
    </div>
</template>

<script>
    export default {
        name: 'Loader',
        data () {
            return {
                msg: 'Welcome to Your Vue.js App'
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/include/Loader.vue